import React from "react";
import MobileHomeDashboard from "../components/thqah/MobileHomeDashboard";
import DesktopHero from "../components/landing/DesktopHero";
import Footer from "../components/thqah/Footer";

/**
 * Landing page.
 * Desktop (>= md): DesktopHero (cinematic marketing) full-width, then the mobile dashboard
 *                  stays centered in its phone column underneath for hands-on browsing.
 * Mobile (< md):   only MobileHomeDashboard is visible (DesktopHero is `hidden md:block`).
 */
export default function Landing() {
  return (
    <div className="relative overflow-hidden">
      <DesktopHero />
      <div className="mx-auto w-full md:max-w-md md:border-x md:border-[#D4AF37]/15 md:shadow-[0_0_80px_rgba(212,175,55,0.08)]">
        <MobileHomeDashboard />
      </div>
      <Footer />
    </div>
  );
}
